

























































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import Divider from "../../components/common/Divider.vue";
import Photo from "../../components/admin/Photo.vue";
import Page from "../../components/admin/Page.vue";
import { Page as PageInterface } from "@/services/settings/entities/page.interface";
import { Photo as PhotoInterface } from "../../services/settings/entities/photo.interface";
import CreatePhotoDialog from "../../components/admin/CreatePhotoDialog.vue";
import privileges from "../../utils/privileges";
import constants from "../../config/constants";
import CreatePageDialog from "../../components/admin/CreatePageDialog.vue";
import CustomPage from "../../components/admin/CustomPage.vue";
import DeletePageDialog from "../../components/admin/DeletePageDialog.vue";

@Component({
  components: {
    Divider,
    Photo,
    CreatePhotoDialog,
    Page,
    CreatePageDialog,
    CustomPage,
    DeletePageDialog,
  },
})
export default class Settings extends Vue {
  loadingCarouselPhotos = false;
  loadingClientPhotos = false;
  loadingPages = false;
  dialogCreate = false;
  pageDialog = false;
  deletePageDialog = false;
  snackbarSuccessDelete = false;
  snackbarErrorDelete = false;
  privilegeName = constants.PRIVILEGE_NAME;
  privilegeType = constants.PRIVILEGE_TYPE;
  componentKey = 1;
  pageKey = 100000;
  customPage: PageInterface | null = null;
  snackbarPageError = false 
  snackbarPageSuccess =false 
  private checkPrivilege(name: string, type: string): boolean {
    return privileges.checkPrivilege(name, type);
  }

  private created(): void {
    this.loadingCarouselPhotos = true;
    this.loadingClientPhotos = true;
    this.loadingPages = true;
    this.$store.dispatch("settings/getPhotos").finally(() => {
      this.loadingCarouselPhotos = false;
      this.loadingClientPhotos = false;
    });
    this.$store.dispatch("settings/getPages").finally(() => {
      this.loadingPages = false;
    });
  }

  private get carouselPhotos(): Array<PhotoInterface> {
    const result = this.$store.getters["settings/getPhotos"].filter(
      (photo: PhotoInterface) =>
        photo.photoType == constants.PHOTO_TYPE.CAROUSEL
    );
    return result;
  }

  private get clientPhotos(): Array<PhotoInterface> {
    const result = this.$store.getters["settings/getPhotos"].filter(
      (photo: PhotoInterface) => photo.photoType == constants.PHOTO_TYPE.CLIENT
    );
    return result;
  }

  private get pages(): Array<PhotoInterface> {
    return this.$store.getters["settings/getPages"];
  }
  get customPages(): Array<Page> {
    return this.$store.getters["settings/getCustomPages"];
  }
  private openDialogCreate(): void {
    this.dialogCreate = true;
    this.componentKey++;
  }
  openPageDialog(page?: any): void {
    this.pageDialog = true;
    this.pageKey++;
    this.customPage = page;
  }
  openDeletePageDialog(page: any) {
    this.deletePageDialog = true;
    this.customPage = page;
  }
}
